module.exports = __webpack_public_path__ + "static/media/slider-home-business-slide-01-image-01.8db02446.png";